
import { Navigate } from 'react-router-dom';
import Loadable from '@components/LazyLoader';
import MenuLayout from '@components/Layout/MenuLayout';
import Quiz from '@pages/MissionCenter/Quiz';
import Feedback from '@pages/MissionCenter/Feedback';

const Login = Loadable(() => import('@pages/Login'))
const Home = Loadable(() => import('@pages/Home'))
const Register = Loadable(() => import('@pages/Registration'))

const MissionCenter = Loadable(() => import('@pages/MissionCenter'))
const WatchAd = Loadable(() => import('@pages/MissionCenter/WatchAd'))

const UploadReceipt = Loadable(() => import('@pages/UploadReceipt'))
const ElectronicInvoice = Loadable(() => import('@pages/UploadReceipt/ElectronicInvoice'))
const VehicleInformation = Loadable(() => import('@pages/UploadReceipt/VehicleInformation'))
const TraditionalInvoice = Loadable(() => import('@pages/UploadReceipt/TraditionalInvoice'))

const ReceiptHistory = Loadable(() => import('@pages/History/ReceiptHistory'))
const RewardHistory = Loadable(() => import('@pages/RewardHistory'))
const Rewards = Loadable(() => import('@pages/Rewards'))
const RewardDetails = Loadable(() => import('@pages/Rewards/RewardDetails'))
const RedeemVoucher = Loadable(() => import('@pages/RewardHistory/RedeemVoucher'))

const Profile = Loadable(() => import('@pages/Profile'))
const CustomerSupport = Loadable(() => import('@pages/Profile/CustomerSupport'))
const TermsAndConditions = Loadable(() => import('@pages/TermsAndConditions'))
const UpdateProfile = Loadable(() => import('@pages/Profile/UpdateProfile'))
const CancelledMembership = Loadable(() => import('@pages/RestrictedUsers/CancelledMembership'))
const Locked = Loadable(() => import('@pages/RestrictedUsers/Locked'))
const DeliveryInfo = Loadable(() => import('@pages/Rewards/DeliveryInfo'))
interface RouteConfig {
    path: string;
    component: React.ReactNode;
}

const authProtectedRoutes: RouteConfig[] = [
    { path: '/home', component: <MenuLayout><Home /></MenuLayout> },
    { path: '/register', component: <Register /> },

    { path: '/mission-center', component: <MenuLayout><MissionCenter /></MenuLayout> },
    { path: '/watch-ad', component: <WatchAd /> },
    { path: '/quiz', component: <Quiz /> },
    { path: '/feedback', component: <Feedback /> },

    { path: '/upload-receipt', component: <MenuLayout><UploadReceipt /></MenuLayout> },
    { path: '/upload-receipt/electronic', component: <ElectronicInvoice /> },
    { path: '/upload-receipt/vehicle', component: <VehicleInformation /> },
    { path: '/upload-receipt/traditional', component: <TraditionalInvoice /> },

    { path: '/rewards', component: <MenuLayout><Rewards /></MenuLayout> },
    { path: '/reward-detail', component: <RewardDetails /> },
    { path: '/reward-history', component: <MenuLayout><RewardHistory /></MenuLayout> },
    { path: '/redeem-voucher', component: <RedeemVoucher /> },
    { path: '/delivery-info', component: <DeliveryInfo /> },

    { path: '/receipt-history', component: <ReceiptHistory /> },
    { path: '/profile', component: <MenuLayout><Profile /></MenuLayout> },
    { path: '/customer-support', component: <CustomerSupport /> },
    { path: '/terms-conditions', component: <TermsAndConditions /> },
    { path: '/update-profile', component: <UpdateProfile /> },

    { path: '/', component: <Navigate to="/home" /> },
    { path: '*', component: <Navigate to="/home" /> }
];

const publicRoutes: RouteConfig[] = [
    { path: '/', component: <Login /> },
    { path: '/cancel-membership', component: <CancelledMembership /> },
    { path: '/locked', component: <Locked /> },
];

export { authProtectedRoutes, publicRoutes };
